enum RouteParams {
  ItemId = 'itemId',
  developmentId = 'developmentId',
  ErrorCode = 'errorCode',
}
export default RouteParams;
